var path = 'src/app/components/general-ledger/common/gl-header.template.html';
var html = "<div class=\"info box\" ng-transclude></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;